import React from 'react';
import { Globe2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { languages } from '../mock';

const Languages = ({ isVisible }) => {
  return (
    <section id="languages" data-section className="py-20 bg-slate-50">
      <div className="container mx-auto px-6">
        <div
          className={`transition-all duration-1000 delay-100 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <h2 className="text-4xl md:text-5xl font-bold text-blue-900 text-center mb-4">
            Languages
          </h2>
          <div className="w-24 h-1 bg-blue-700 mx-auto mb-12"></div>

          <div className="max-w-4xl mx-auto">
            <Card className="border-2 border-slate-200 hover:border-blue-700 hover:shadow-xl transition-all duration-300">
              <CardHeader className="bg-slate-50">
                <CardTitle className="flex items-center gap-2 text-blue-900">
                  <Globe2 size={24} className="text-blue-700" />
                  Language Proficiency
                </CardTitle>
              </CardHeader>
              <CardContent className="pt-6">
                <div className="space-y-6">
                  {languages.map((language, index) => (
                    <div key={index} className="space-y-2">
                      <div className="flex justify-between items-center mb-2">
                        <div>
                          <span className="text-lg font-semibold text-slate-800">{language.name}</span>
                          <span className="text-slate-600 ml-3">({language.level})</span>
                        </div>
                        <span className="text-blue-700 font-semibold">{language.proficiency}%</span>
                      </div>
                      <div className="w-full bg-slate-200 rounded-full h-3 overflow-hidden">
                        <div
                          className="bg-gradient-to-r from-blue-600 to-blue-700 h-3 rounded-full transition-all duration-1000 ease-out"
                          style={{
                            width: isVisible ? `${language.proficiency}%` : '0%'
                          }}
                        ></div>
                      </div>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Languages;